import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year5/Spring/DecimalsAndPercentages/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'DecimalsAndPercentages',
  field: 'Number',
  weeks: [6, 8],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/DecimalsAndPercentages/1DecimalsUpTo2DecimalPlaces" */ './1DecimalsUpTo2DecimalPlaces'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/DecimalsAndPercentages/2EquivalentFractionsAndDecimalsTenths" */ './2EquivalentFractionsAndDecimalsTenths'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/DecimalsAndPercentages/3EquivalentFractionsAndDecimalsHundredths" */ './3EquivalentFractionsAndDecimalsHundredths'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/DecimalsAndPercentages/4EquivalentFractionsAndDecimals" */ './4EquivalentFractionsAndDecimals'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/DecimalsAndPercentages/5ThousandthsAsFractions" */ './5ThousandthsAsFractions'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/DecimalsAndPercentages/6ThousandthsAsDecimals" */ './6ThousandthsAsDecimals'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/DecimalsAndPercentages/7ThousandthsOnAPlaceValueChart" */ './7ThousandthsOnAPlaceValueChart'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/DecimalsAndPercentages/8OrderAndCompareDecimalsSameNumberOfDecimalPlaces" */ './8OrderAndCompareDecimalsSameNumberOfDecimalPlaces'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/DecimalsAndPercentages/9OrderAndCompareAnyDecimalsWithUpTo3DecimalPlaces" */ './9OrderAndCompareAnyDecimalsWithUpTo3DecimalPlaces'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/DecimalsAndPercentages/10RoundToTheNearestWholeNumber" */ './10RoundToTheNearestWholeNumber'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/DecimalsAndPercentages/11RoundTo1DecimalPlace" */ './11RoundTo1DecimalPlace'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/DecimalsAndPercentages/12UnderstandPercentages" */ './12UnderstandPercentages'
        )
    }),
    // Step 13
    newSmallStepContent({
      ...BlockModel.smallSteps[12],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/DecimalsAndPercentages/13PercentagesAsFractions" */ './13PercentagesAsFractions'
        )
    }),
    // Step 14
    newSmallStepContent({
      ...BlockModel.smallSteps[13],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/DecimalsAndPercentages/14PercentagesAsDecimals" */ './14PercentagesAsDecimals'
        )
    }),
    // Step 15
    newSmallStepContent({
      ...BlockModel.smallSteps[14],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/DecimalsAndPercentages/15EquivalentFractionsDecimalsAndPercentages" */ './15EquivalentFractionsDecimalsAndPercentages'
        )
    })
  ]
});
export default Block;
